import React from "react";
import {
  Dialog,
  Button,
  makeStyles,
  createStyles,
  Theme
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalButton: {
      marginRight: 12,
      color: "#ffffff",
      padding: "7px 22px",
      textTransform: "none",
      borderRadius: 4,
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.83,
      boxShadow: "1px 2px 2px 0 rgba(0, 0, 0, 0.24)",
      backgroundColor: "#5566d6",
      marginTop: 18,
      borderWidth: 0,
      "&:hover": {
        backgroundColor: "#5566d6 !important"
      }
    },
    cancelBtn: {
      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.22)",
      backgroundColor: "#ffffff",
      border: "solid 1px #ececec",
      color: "#32325d",
      "&:hover": {
        backgroundColor: "#ffffff !important"
      }
    }
  })
);
export interface ConfirmFormModalProps {
  confirmCondition: boolean;
  isOpen: boolean;
  handleClose: any;
  header: any;
  body: any;
  primaryBtnName?: string;
  closeDisable?: boolean;
  SecondaryBtnName?: string;
  successHandler?: any;
  subHeaderHtml?: any;
  style?: any;
  className?: any;
  size?: any;
  disableBackdropClick?: any;
  hidePrimaryBtn?: boolean;
  hideSecondaryBtn?: boolean;
  containerStyle?: any;
  footerStyles?: any;
  headerStyles?: any;
}
export const ConfirmFormModal = (props: ConfirmFormModalProps) => {
  const classes = useStyles();
  const {
    isOpen,
    handleClose,
    header,
    subHeaderHtml,
    body,
    primaryBtnName,
    SecondaryBtnName,
    closeDisable,
    successHandler,
    style,
    className,
    size,
    confirmCondition,
    disableBackdropClick,
    hidePrimaryBtn,
    hideSecondaryBtn,
    containerStyle,
    footerStyles,
    headerStyles
  } = props;
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className={className}
      style={style}
      maxWidth={size}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-modal-description"
      data-testid="confirm-component"
      disableBackdropClick={disableBackdropClick}
    >
      <div
        style={{
          // padding: 20,
          width: "100%",
          maxWidth: "100%",
          borderBottom: "#f2f2f2",
          ...containerStyle
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexGrow: 1,
              alignItems: "center",
              padding: 20,
              ...headerStyles
            }}
          >
            <div
              style={{ fontSize: 14, fontWeight: 600, color: "#32325d" }}
              data-testid="header-text"
            >
              {header}
            </div>
            {closeDisable ? null : (
              <CloseIcon
                htmlColor="#414169"
                style={{ width: 16, height: 16, cursor: "pointer" }}
                onClick={handleClose}
              />
            )}
          </div>
          {subHeaderHtml && <>{subHeaderHtml}</>}
        </div>

        <div
          style={{
            fontSize: 12,
            lineHeight: 1.5,
            color: "#32325d",
            marginTop: 20
          }}
          data-testid="body-text"
        >
          {body}
        </div>
        {/* {!hidePrimaryBtn && !hideSecondaryBtn &&  */}
        <div style={{ marginTop: 50, padding: 20, ...footerStyles }}>
          <Button
            hidden={hidePrimaryBtn || false}
            disabled={confirmCondition}
            variant="contained"
            color="primary"
            className={classes.modalButton}
            onClick={successHandler}
            data-testid="primaryBtn"
          >
            {primaryBtnName || "OK"}
          </Button>
          <Button
            hidden={hideSecondaryBtn || false}
            variant="contained"
            className={`${classes.modalButton} ${classes.cancelBtn}`}
            onClick={handleClose}
            data-testid="secondBtn"
          >
            {SecondaryBtnName || "Cancel"}
          </Button>
        </div>
        {/* } */}
      </div>
    </Dialog>
  );
};
